<template>
<div id="Vue"  style="background:#eceaea;">

 
  
 
<el-row   >   
<el-col :span="20" :offset="1" >
<el-row style=" padding:20px;margin-top:10px;background: #fff; " justify="center" :gutter="20" > 
   
  <el-col :span="10" :offset="4"  >
 
      <div style="padding: 2px;color: #909399;margin-top:20px;">
       
								
             <span></span> <font>1世界各大贸易国相关产品海关提单数据查询  <span style="color:red;font-size:15px"> </span></font><br>
             <span></span> <font>2贸易数据可按产品描述、采供商、HS编码查阅</font><br>
             <span></span> <font>3采供商名录可按产品描述、HS编码等维度查阅</font><br> 
             <span></span> <font>4世界各国公司数据及联系方式(会员服务)</font><br>
			 <span></span> <font>5广交会采购商数据及联系方式(会员服务)</font><br><br><br> 
			 
			 <span></span> <font>微信小程序 访问</font><br> 
			 <img src="https://cdn1.myferp.com/mini/mini.jpg" />
      </div>

  </el-col>
  <el-col :span="4" :offset="4"  >
 
      <div style="padding: 2px;display:flex;margin-top:20px;">
	  								
		 <div class="pay-type">
              <span style="text-align:center"> <el-button type="primary" icon="el-icon-search" @click="customs('us')" style="width:150px">海关数据</el-button></span></br></br>
			  <span style="text-align:center" > <el-button plain type="success" icon="el-icon-message" @click="email()"  style="width:150px">全球公司数据</el-button></span></br></br>
			  <span style="text-align:center" > <el-button plain type="warning" icon="el-icon-news" @click="gd()" style="width:150px">广交会数据</el-button></span></br></br>
			  <!--span style="text-align:center" > <el-button plain type="primary" icon="el-icon-user" @click="payment()" style="width:150px">会员服务</el-button></span-->
			  
         </div>
 
								
							 
   
      </div> 
  </el-col>

  
		
</el-row>
  <!--el-row style=" padding:20px;background: #fff; " justify="center" :gutter="20">
  <el-row type="flex" justify="center" style="padding-bottom:8px">  </el-row>
      <el-col :span="10" :offset="4" style="padding:10px">
	    为了能够更好地为您提供免费海关数据服务，谢谢您的支持!
		 
	  </el-col>
      <el-col :span="4" :offset="4"  style="padding:10px"> 
		<el-button plain type="success" icon="el-icon-postcard" @click="donation()" style="width:150px">捐赠</el-button>
	  </el-col>	  
  </el-row-->
  
    
  <el-row id="customData" style="padding:10px; background: #fff;margin-top:20px " type="flex" justify="left" :gutter="20"  >	
  <el-col :span="24"  > 
 
  <el-skeleton v-if="loading == true"    animated />
  
  <el-form :inline="true" v-loading="loading"> 			

  <el-form-item style="width:23%;height:160px" v-for="(item,index) in tableData  ">
  <el-card style="width:99%;height:160px;"  shadow="hover" @click.native="customs('{{item.countryCode}}')" >
       
      <div style="padding: 2px;display:flex;flex-direction:column;overflow: hidden;text-overflow: ellipsis; ">
	    <div style="padding: 2px;display:flex;flex-direction:row;overflow: hidden;text-overflow: ellipsis; ">
        <span  style="text-align:center"><img :src="item.flagUrl" style="width:60px;height:60px"></img></span>
		<span   style="margin-left:2px;text-align:center;font-size:15px;color:#111;display:inline-block;width:90%;">{{item.countryName}} </span> 
        </div> 
		<div style="padding: 2px;display:flex;flex-direction:row;margin-left:20px;overflow: hidden;text-overflow: ellipsis;">
		 
		<span   style="text-align:center;font-size:12px;color:#909399">更新至:{{ item.latestDate}} </span> 
		</div>
      </div>
    </el-card> 
   </el-form-item>	 
	</el-form> 
 
     
  </el-col> 
  </el-row>
   
 
</el-col>
</el-row>
	
 
	
</div>
</template>
<style>
  .el-col {
    border-radius: 4px;
  }
  .time {
    font-size: 13px;
    color: #999;
  }
  
  .bottom {
    margin-top: 13px;
    line-height: 12px;
  }

  .button {
    padding: 0;
    float: right;
  }

  .image {
    width: 100%;
    display: block;
  }


 
</style>

<script>
 
export default {
 
        data () {
            return {
	    	is_loading: false,
		    userInfo: {},
			customShow : true,
			erpShow: false,
			amount: 0, 
			sk_id: 0,
			sk_name: '', 
			pay_mode: 'ali',
			tableData: [],
			loading: false,
			} 
        },
        methods: { 

		  customs(val){
			       this.$router.push({
					name: 'customsSearch',
					params: {
					  nation: val
					}
				    });
		  },
		  email(){
			       this.$router.push({
					name: 'emailSearch',
					params: {
					  sometext: ''
					}
				    });
		  },
		  gd(){
			       this.$router.push({
					name: 'gdSearch',
					params: {
					  sometext: ''
					}
				    });
		  },		  
		  payment(){
			       this.$router.push({
					name: 'payment',
					params: {
					  sometext: ''
					}
				    });
		  },
		  donation(){
			       this.$router.push({
					name: 'donation',
					params: {
					  sometext: ''
					}
				    });
		  },
		},
	    created(){
		  var Ip=returnCitySN['cip']
          var cityname=returnCitySN['cname']
         // localStorage.setItem('Ip', Ip)
         // console.log(localStorage.getItem('Ip', Ip))
         // localStorage.setItem('cityname', cityname)
         // console.log(localStorage.getItem('cityname', cityname));
          let visitor = 'IP:';
          visitor = visitor + Ip + ' province:' + cityname; 
		  console.log(visitor);		 
		  
		  let info = {};
		  let user_id = 0;
		  let userInfo = localStorage.getItem('userInfo'); 
		  console.log('userInfo:' + userInfo);
		  if (userInfo != '' && userInfo != null && typeof userInfo != undefined){
			 info = JSON.parse(userInfo);
			 user_id = info.id;  
			}
			
		  let geturl = window.location.href; //get url param
		  let getqyinfo = geturl.split('?')[1]; 
		  let getqys = new URLSearchParams('?'+getqyinfo);
		  let source = getqys.get('source'); 
		  $.ajax({
			  type: "post",
			  data:  {user_id: user_id, 
					  ipInfo: visitor,	
					  source: source,
					  
					  },
			  url: "https://www.myferp.com/admin/auth/ipUpdate",
			  dataType: "json",  //返回类型为 json    
			  error: function(XMLHttpRequest, textStatus, errorThrown) { 
			  },
			  success: function (data) {
				console.log('info:' + data);
			  }
		  });
		  let that = this; 
		  that.loading = true;
		  $.ajax({
			  type: "post",
			  data:  {   },
			  url: "https://www.myferp.com/admin/auth/countryList",
			  dataType: "json",  //返回类型为 json    
			  error: function(XMLHttpRequest, textStatus, errorThrown) { 
			  },
			  success: function (data) {
				console.log('info:' + data);
				that.tableData = data.data.info;
				that.loading = false;
			  }
		  });
		/*  this.$axios({
						url : '/api/cityjson?ie=utf-8',
						method : 'get'
					}).then((response)=>{
					}).catch((error)=>{
						console.log(error.response.status);
					}).then(()=>{
						console.log(" finally"); 
						});
						
		*/				
 
		    // http://pv.sohu.com/cityjson?ie=utf-8
		  },
		}
</script>
 


// WEBPACK FOOTER //
// src/components/customs/customsIndex.vue